<template>
  <div class="mx-2 p-4 bg-secondary-3 rounded">
    <div class="d-flex justify-content-between mb-2">
      <custom-balloon
        :background-color="item.status?.color"
        :text="item.status?.name"
        dot
      />
      <div v-if="!isReadOnly" @click.stop="quit">
        <i class="fas fa-times-circle pointer text-red pr-1" />
      </div>
    </div>

    <div class="row">
      <div class="col-2 border-right">
        <div class="data-name">Fecha:</div>
        <div class="font-weight-bold">{{ item.date | date }}</div>
        <div class="data-name">{{ item.date | time }}</div>
        <div class="data-name mt-3">Añadido por:</div>
        <div>{{ item.user?.name }}</div>
      </div>

      <div class="col px-4">
        <div class="data-name">Asunto:</div>
        <div>{{ item.subject | empty }}</div>
        <div class="data-name mt-3">Comentario:</div>
        <div>{{ item.comment | empty }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomBalloon from 'custom-balloon';

export default {
  name: 'BinnacleTabResultRow',
  components: {
    CustomBalloon,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    quit() {
      this.$emit('quit', this.item);
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
